
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqBzn0Zf2mUM1lJa9GY7I7tU_gDbps5ljVipjdVsfw6JIMeta } from "/codebuild/output/src970645250/src/src/pages/faq.vue?macro=true";
import { default as menucuVGo7qVYS7AEP_7a9WMC8tzuodJjhGI1bJG8EYKRh4Meta } from "/codebuild/output/src970645250/src/src/pages/menu.vue?macro=true";
import { default as index_45YW_45lD8HpT85Duv_45UCGt4j8W6ypwK5cPqmDrWhdHK3QMeta } from "/codebuild/output/src970645250/src/src/pages/index.vue?macro=true";
import { default as contactkc_X961dybOcoy8cfAKYtb2iOd9Ipoy6K7pcgI9TAwAMeta } from "/codebuild/output/src970645250/src/src/pages/contact.vue?macro=true";
import { default as tutorialJT6bpODYDhNoFrPXlF_45p_45ug5TczXVSFzQ7cqq82QvfMMeta } from "/codebuild/output/src970645250/src/src/pages/tutorial.vue?macro=true";
import { default as agreementKWSCWCC1NlLLYYY8Hi6kB52iZHvjBzAWvFtbrA6L4kgMeta } from "/codebuild/output/src970645250/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass57_MfzXjNFHgq9kGupYd_u4Nq4k8jeI4ivonHHBs9PoMeta } from "/codebuild/output/src970645250/src/src/pages/about-pass.vue?macro=true";
import { default as indexXCp8SIqmJTU4bICgwx4cKNiJrvpJrEt86Y7JFXRtsGsMeta } from "/codebuild/output/src970645250/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93iVy0OUaVtETHR8qJPFVReo7w5GSVZZhMbJkViaYBA2sMeta } from "/codebuild/output/src970645250/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancebhHaumhqviTQXm_45Ac7Sty_45ss3MEGhhaQBUlnL_45ngpDgMeta } from "/codebuild/output/src970645250/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93elqfB6PIz9lL2hVDUJKScGVrFMN63GV0xRoA0WkTETUMeta } from "/codebuild/output/src970645250/src/src/pages/notice/[id].vue?macro=true";
import { default as indexpsmMTlhC3eYDVj8x5ezFgNT6U1Acgp510higDn2pQ_45wMeta } from "/codebuild/output/src970645250/src/src/pages/coupon/index.vue?macro=true";
import { default as indexkSzqVAZFpejntL7gXRipGkiQEjunxPA8qqXXfBLVXlMMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/index.vue?macro=true";
import { default as indext3FaG7D1hEHpn8LXB31pZ8sLiYixSylRAu1psyB9qogMeta } from "/codebuild/output/src970645250/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93AhKpxQxKP9TWmCnzXEBUkrp8TgfsOGi0yA9_z66DR_45sMeta } from "/codebuild/output/src970645250/src/src/pages/parking/[id].vue?macro=true";
import { default as indexrPPIGiP61giOxV8RkqiZvCMge2imWfEc_PhrWGexNWAMeta } from "/codebuild/output/src970645250/src/src/pages/history/index.vue?macro=true";
import { default as indexSICLjKpMWMY45WyHH8vRuNeTK5WsAFdIvMmolYC1zmoMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/index.vue?macro=true";
import { default as indexOFVUx511abx7KU5U_45gnROj0dT5_45hktvd8Q_yr8Uaq7wMeta } from "/codebuild/output/src970645250/src/src/pages/sign-in/index.vue?macro=true";
import { default as index6v8DX3NiIzTY58CdzGkWfam_45BJrx5pCaeQgbQeAuAKkMeta } from "/codebuild/output/src970645250/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavilpJkfluSVVRcCp8aSzLvLf3JdgyQq8rs4winxhyOuqEMeta } from "/codebuild/output/src970645250/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editzjw8Me1OZxT_geEV7NDUaoWeZ4gdlpLFXsU3Ijrf4SgMeta } from "/codebuild/output/src970645250/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementoWx7rZLkZwtkyRFtR5LQpl_V3dL_45wLzmmlZ7zJbP7GMMeta } from "/codebuild/output/src970645250/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexrdJBYRvstYVfVjkDWda9V4X99R6X5DKwmyQSLCnARnkMeta } from "/codebuild/output/src970645250/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dkV261sl63ugilNJLlVFCSv0ni923B2d26_45QG2iNKc_sMeta } from "/codebuild/output/src970645250/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm9G3GI5SqMrOisUS5DihAj4pRsMRL9SUoeUuksDJQyFsMeta } from "/codebuild/output/src970645250/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexKOGIsZ33kBdoRGAE_zsI1DHnGfB3OIjK_vewZuwEcogMeta } from "/codebuild/output/src970645250/src/src/pages/card/create/index.vue?macro=true";
import { default as indexIdCE0gGZc0JzFdcfVk1UFvDE7jEULm8CIxziplQP7jcMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmmLxvitEdCYSXMXcYGvsTYWZr3fPcT2cuFQ9i6k9pPvEMeta } from "/codebuild/output/src970645250/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm1hqtVwNtGMpCy8IrK_apiCZAI5xMAw7Zo9E4yK7u1V0Meta } from "/codebuild/output/src970645250/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_45RwCI0TkGu39OBipwycsS7j_cwBW016_45yKVxF8xFYx8Meta } from "/codebuild/output/src970645250/src/src/pages/membership/complete.vue?macro=true";
import { default as registerV07QzjSXUNQJ_EPspxeVkLtukDRNr10_Gkg9vorcmQoMeta } from "/codebuild/output/src970645250/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93JySzx6so3PMk3wAtrSYcjjteXy5dcEQhZU1ggdUxlLMMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmI3FF7t6kaE7j8qO1eRODr2YNzp4cHUmOEReKHML_ICgMeta } from "/codebuild/output/src970645250/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93ITFojj_zNb_O8Wkxj4Rp_TvGwQCzQeMfVTHBaUzgzikMeta } from "/codebuild/output/src970645250/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index_452G_45pxkF_45PhCugB54IbFhvoalaoNqf_45AGfiuhV0Xe7cMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeW_45CjrYR5RNI_45QkK1zMVCv8_yujcNZs6GpS0_XnL2lmAMeta } from "/codebuild/output/src970645250/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codetMKS6Lls0h_453vyXOEo8Fgs_450h7WOQUjRErxsRLlm9j4Meta } from "/codebuild/output/src970645250/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete6ocRjTBKNNjMpX3phgKwinCebUzrMsIBOIOHFYpT4ggMeta } from "/codebuild/output/src970645250/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerF36B6rjl1o5b4sJegm5zKWhTFR6ihzbITlzcPW2_455dwMeta } from "/codebuild/output/src970645250/src/src/pages/contact-form/register.vue?macro=true";
import { default as completefuaBq_45DuCnuormbjUimkGwyje0HQ0Ka455nH4hiJpfkMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexq52yX6n7G1LkTEVcLxKPuY0Lcg6z57WZSf1osm_454pW4Meta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmecB4x_45dYXAkNVw5oS4EHUmymPhdkvSU1_ML29GY3FLgMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeB1VP_45D0Qmyh8b1DmERew0ceWlK16bQ8YbyqF_458ToixsMeta } from "/codebuild/output/src970645250/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexpLDeJLvaqM3f_QHTa0BA9VZXASN7I7Y5aYTSXcYCNT4Meta } from "/codebuild/output/src970645250/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Dx_45n_45o19jzu5uhqFKGFTjpYL3dh92oM0xcoWG7d31JwMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completenkYMivM7BrfRf0PR4_TYyjDT4PuiXljbAsmyXUPAuVIMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias_45_45UPHJX_456xA8iHMfdf1CitnFWboQn9mkV_457kNLPCEq4Meta } from "/codebuild/output/src970645250/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplecSA_45yRWgisuITa3g6ZNaA8vrfVodrCw6GoZA7TiYIM8Meta } from "/codebuild/output/src970645250/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailN4oMAgB_45iev82QYlDpV_45j4pH8ehwJd_45N8Qj_cMCOCwIMeta } from "/codebuild/output/src970645250/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmEqJXjndi5ppNrlFWFTcGKWMjeVo9gORuBDYW6f79XicMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentCtQoNDF6QN2Wq1lVl75tZV6yUdGisgmszdImYKAUPQQMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmWE8hUosFRDlOonj2eAEq9Eg4wjLKcYsT1_45MSHzNbTfsMeta } from "/codebuild/output/src970645250/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateJ8Uux6DwSZpC_8FFlAF1Dilk4ieQnSyhoPwqH__45JeUYMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completexYQ4EPNbDqpIH15Cawc2XBwsvnuE6xT9DrTKWXBmOlIMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeCba_45SD8s301t8eJz7pRJeBc2YtooKFWVcB0yrHKklbwMeta } from "/codebuild/output/src970645250/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordZ73JBFBqz00_ELOAPa_45FuRDfK_45OsfoagSVn0o5B_QrkMeta } from "/codebuild/output/src970645250/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasBDXApdhOhIiRJPQnr94fxhX8tvoxnJtqeo4CHJAD5LkMeta } from "/codebuild/output/src970645250/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerkmKfLdBsP4zAC7RhaEhEZvJF_pHkH4oMwjIx509BdYgMeta } from "/codebuild/output/src970645250/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code1K5foqr24hhgMncXkgFIYzXcCzt9JTBu_45_45C2Ohr47BIMeta } from "/codebuild/output/src970645250/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexmEHCanO03bNNQsKXPQ6MieZ3YC5H4wySKm__45XlmOVvAMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexkfAbeqlbpiMuL3_E5ytNftHyPmJo6ImK3VHAjNx89_45sMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexM5bIBm2hXdPxH2rrXreAAo3V3SDe9PQiKTGeXdT_eDEMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexem7a4CP7GPZgka5hsg9NRRNLLE0t2zfz_9dqcYJcxYUMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updategox2cjXnEQsg12EnyGV1sDWmNs5DPVHPeKPfDku4_pgMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeTvanIzOkBoA9l12wQEz2dYXOUyxIQQMWBSscBQzzBkQMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmCVb0pwzws_45DWr9DzwgeqhKJlMT4z8u5MA2wvv_45D_45MywMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index0IA4wGV43yGGdzmdjzJh0tX8vk8ruwN8hB6ITeCl5loMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completer0UOi6OL4__45hL95wInXkS_Z6EODv1Lyluoq1OTKXVdkMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateEa50ITnXez0PHQlTiS3ogFkV4pb_45X1peJ6Hq14C38DMMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexJcQcQrmQpPqIMoopNKVhacyu_45zy2IkaMnc5rXiihxvsMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexe2ZLiX4Ca1WTfnyGos30edkVbVIbmPQ6qH47hdxnL4cMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completekRBTrxyFcia82020jYLhMOloLWSiDqxGghI3w7vPTVsMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexe0rdAiERd57IDfSgR7Dn5hCVwmrtnxNjiiGIkV2iF2QMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeJOUPvQBK_45ygGNhlvH3BHF2b1_5BP1ByWcvkCpf25ZvoMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexTQpl3WUzMrpu6vA6Io6372OhU72Lf9e_45ZL_ooG8tWKgMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexcg2eGNrPVcFcx3iX9xE7_xKrtrwMNT7ZiMmYp3ljF20Meta } from "/codebuild/output/src970645250/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index166g2sBSWRUrvRJeXSghtsfS9w5iix3p7mI4S2DY6SQMeta } from "/codebuild/output/src970645250/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateQ7y5u_45o_45Ce0CxwvesoPg71OlACwCtGAxGWyUAD_45Lu4cMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmmhao9oVlaeaaKZU3QR_jyu0fV9H9ipqssNS0jm0oC6UMeta } from "/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src970645250/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menucuVGo7qVYS7AEP_7a9WMC8tzuodJjhGI1bJG8EYKRh4Meta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index_45YW_45lD8HpT85Duv_45UCGt4j8W6ypwK5cPqmDrWhdHK3QMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src970645250/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src970645250/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src970645250/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src970645250/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src970645250/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexpsmMTlhC3eYDVj8x5ezFgNT6U1Acgp510higDn2pQ_45wMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexrPPIGiP61giOxV8RkqiZvCMge2imWfEc_PhrWGexNWAMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexOFVUx511abx7KU5U_45gnROj0dT5_45hktvd8Q_yr8Uaq7wMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index6v8DX3NiIzTY58CdzGkWfam_45BJrx5pCaeQgbQeAuAKkMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src970645250/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src970645250/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexKOGIsZ33kBdoRGAE_zsI1DHnGfB3OIjK_vewZuwEcogMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmmLxvitEdCYSXMXcYGvsTYWZr3fPcT2cuFQ9i6k9pPvEMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm1hqtVwNtGMpCy8IrK_apiCZAI5xMAw7Zo9E4yK7u1V0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_45RwCI0TkGu39OBipwycsS7j_cwBW016_45yKVxF8xFYx8Meta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerV07QzjSXUNQJ_EPspxeVkLtukDRNr10_Gkg9vorcmQoMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmI3FF7t6kaE7j8qO1eRODr2YNzp4cHUmOEReKHML_ICgMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeW_45CjrYR5RNI_45QkK1zMVCv8_yujcNZs6GpS0_XnL2lmAMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codetMKS6Lls0h_453vyXOEo8Fgs_450h7WOQUjRErxsRLlm9j4Meta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete6ocRjTBKNNjMpX3phgKwinCebUzrMsIBOIOHFYpT4ggMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerF36B6rjl1o5b4sJegm5zKWhTFR6ihzbITlzcPW2_455dwMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmecB4x_45dYXAkNVw5oS4EHUmymPhdkvSU1_ML29GY3FLgMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeB1VP_45D0Qmyh8b1DmERew0ceWlK16bQ8YbyqF_458ToixsMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexpLDeJLvaqM3f_QHTa0BA9VZXASN7I7Y5aYTSXcYCNT4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completenkYMivM7BrfRf0PR4_TYyjDT4PuiXljbAsmyXUPAuVIMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplecSA_45yRWgisuITa3g6ZNaA8vrfVodrCw6GoZA7TiYIM8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailN4oMAgB_45iev82QYlDpV_45j4pH8ehwJd_45N8Qj_cMCOCwIMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmEqJXjndi5ppNrlFWFTcGKWMjeVo9gORuBDYW6f79XicMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentCtQoNDF6QN2Wq1lVl75tZV6yUdGisgmszdImYKAUPQQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmWE8hUosFRDlOonj2eAEq9Eg4wjLKcYsT1_45MSHzNbTfsMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completexYQ4EPNbDqpIH15Cawc2XBwsvnuE6xT9DrTKWXBmOlIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeCba_45SD8s301t8eJz7pRJeBc2YtooKFWVcB0yrHKklbwMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordZ73JBFBqz00_ELOAPa_45FuRDfK_45OsfoagSVn0o5B_QrkMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src970645250/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerkmKfLdBsP4zAC7RhaEhEZvJF_pHkH4oMwjIx509BdYgMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code1K5foqr24hhgMncXkgFIYzXcCzt9JTBu_45_45C2Ohr47BIMeta || {},
    component: () => import("/codebuild/output/src970645250/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src970645250/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src970645250/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]